import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import React from 'react';

const SKELETON_PARAGRAPHS = [
  ['100%', '96%', '99%', '58%'],
  ['98%', '100%', '95%', '67%'],
  ['97%', '94%', '100%', '49%'],
  ['99%', '92%', '100%', '73%'],
];

const DraftGenerationSkeleton: FC = () => {
  return (
    <div
      className="ai-draft-skeleton"
      role="status"
      aria-busy="true"
      data-test-id="ai-draft-skeleton"
    >
      <div className="ai-draft-skeleton-status">
        <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
        Generating draft from source documents…
      </div>
      <div className="ai-draft-skeleton-lines" aria-hidden="true">
        {SKELETON_PARAGRAPHS.map((widths, paragraph) => (
          <div className="ai-draft-skeleton-paragraph" key={paragraph}>
            {widths.map((width, index) => (
              <div
                key={index}
                className="ai-draft-skeleton-line"
                style={{ width }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DraftGenerationSkeleton;
